<template>
    <div>
        <FormInput label="CÓDIGO QR" v-model="abonado.qr_code" id="qr_code" :disabled="disabled" />
        <FormInput name="dni - pasaporte - nie" label="DNI - PASAPORTE - NIE" v-model="abonado.dni" id="dni" :disabled="disabled" />
        <FormInput name="nº de abonado" class="mb-3 mb-lg-4" label="Nº DE ABONADO" v-model="abonado.n_abonado" id="n_abonado" :disabled="disabled" />

        <button type="submit" @click="submit" class="button large-button effect-button" :disabled="disabled"><span>Buscar</span></button>

        <div v-if="buscando" class="col-12">
            <LoaderComponent/>
        </div>

        <div class="col-12" v-if="error">
            <section class="padding-vertical-content">
                <div class="container">
                    <div class="row">
                        <div v-if="!amigo_abonado" class="col-12">
                            <div class="alert alert-danger" role="alert">
                                <template v-if="error != 'comprado'">
                                    <h4 v-if="motivo === 'no_permitido'">Este Abono no es válido para este evento</h4>
                                    <h4 v-else-if="motivo === 'ya_disponible'">El abonado ya tiene permitido la entrada al evento</h4>
                                    <h4 v-else-if="motivo === 'sancionado'">El abono ha sido sancionado hasta el {{ sancion_fecha_fin }}.</h4>
                                    <h4 v-else>{{ error }}</h4>
                                </template>
                                <p v-else>
                                    <b>¡Ya activaste tu abono!</b>
                                    <br/>
                                    Te recordamos que un abono, únicamente puede disponer de una entrada por lo que no es posible adquirir más entradas con este número de abonad@ y este dni.
                                    <br/>
                                    <b>Cualquier cuestión nos tienes en {{ manager.email_incidencias || 'info@compralaentrada.com' }}</b>
                                </p>
                            </div>
                        </div>
                        <div v-else class="col-12">
                            <div class="alert alert-danger" role="alert">
                                <div v-if="error != 'comprado'">
                                    <template v-if="motivo === 'superado_maximo_numero_de_pedidos'">
                                        <h4>El número de abono que estás introduciendo ya ha superado el número máximo de pedidos.</h4>
                                    </template>
                                    <template v-else-if="motivo === 'no_permitido'">
                                        <p>El número de abono que estás introduciendo está fuera del rango permitido para este partido / momento.</p>
                                    </template>
                                    <template v-else-if="motivo === 'maximo_numero_pedidos_es_0'">
                                        <h4>En este evento no se permite comprar entradas como abono amig@.</h4>
                                    </template>
                                    <template v-else-if="motivo === 'sancionado'">
                                        <h4>El abono ha sido sancionado hasta el {{ sancion_fecha_fin }}.</h4>
                                    </template>
                                    <template v-else>
                                        <h4>{{ error }}</h4>
                                        <p>Por favor, escriba un correo a {{ manager.email_incidencias || 'info@compralaentrada.com' }} indicando su numero de abonado, nombre, apellidos y dni.</p>
                                        <p v-if="configuracion.hash_teatro == 'I0QtpDfZsTkgWKert1Gp'">
                                            En el caso de que no exista tu número de abonado contacte con en club en:
                                            Teléfono de contacto: 968.012.412
                                            Email de contacto: {{ manager.email_incidencias || 'info@compralaentrada.com' }}
                                        </p>
                                    </template>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    </div>    
</template>

<script>
    export default {
        props: {
            amigo_abonado: {
                type: Boolean,
                default: false
            },
            disabled: {
                type: Boolean,
                default: false
            }
        },
        data() {
            return {
                error: false,
                buscando: false,
                abonado: {},
                data_abonado: {},
                motivo: '',
                sancion_fecha_fin: '',
            }
        },
        computed: {
            manager() {
                return this.$store.getters.getFooter;
            },
            configuracion() {
                return this.$store.getters.getConfig;
            }
        },
        methods: {
            async submit() {
                if (this.amigo_abonado) {
                    this.buscarAmigoAbonado();
                } else {
                    this.buscarAbonado();
                }
            },
            buscarAbonado() {
                this.error = false;
                this.buscando = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado.dni,
                        qr_code: this.abonado.qr_code,
                        n_abonado: this.abonado.n_abonado,
                        precio_reducido: true,
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        taquilla: true
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado.dni,
                    n_abonado: this.abonado.n_abonado,
                    precio_reducido: true,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    taquilla: true

                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar'), params).then(res => {
                    this.buscando = false;
                    if(res.data.error) {
                        this.error = res.data.error;
                    } else {
                        if(res.data.comprado) {
                            this.error = 'comprado';
                        } else {
                            this.$emit('abonadoEncontrado', res.data)
                        }
                    }
                }).catch(error => {
                    this.error = 'El abonado no existe';
                    this.motivo = error.response.data.motivo;
                    this.sancion_fecha_fin = error.response.data.fecha_fin;
                    this.buscando = false;
                    this.mostrar_opciones = false;
                });
            },
            buscarAmigoAbonado() {
                this.error = false;
                this.buscando = true;

                const params = {
                    filters: {
                        tid: this.configuracion.hash_teatro,
                        dni: this.abonado.dni,
                        qr_code: this.abonado.qr_code,
                        n_abonado: this.abonado.n_abonado,
                        precio_reducido: true,
                        evento_id: this.$route.params.evento_id,
                        sesion_id: this.$route.params.sesion_id,
                        taquilla: true
                    },
                    tid: this.configuracion.hash_teatro,
                    dni: this.abonado.dni,
                    n_abonado: this.abonado.n_abonado,
                    precio_reducido: true,
                    evento_id: this.$route.params.evento_id,
                    sesion_id: this.$route.params.sesion_id,
                    taquilla: true

                }

                this.$store.dispatch(this.config.getVuexAlias('front.abonados.buscar-amigo'), params).then(res => {
                    this.$emit('abonadoEncontrado', res.data)
                }).catch(error => {
                    this.$emit('abonadoEncontrado', false)
                    this.motivo = error.response.data.motivo;
                    this.error = 'El abonado no existe';
                }).finally(() => {
                    this.buscando = false;
                });
            }
        },
    }
</script>

<style>
@media (max-width: 768px) {
    .alert {
        width: 85vw !important;
    }
}
</style>
